
export default {
    list: [],
    page: {
        name: null,
        content: null,
        slug: null
    }
}